/** Parse table input (any currency symbol/code, thousands dot, decimal comma) to number. */
export function parseGermanBudgetNumber(raw) {
  if (raw == null) return NaN
  // Strip anything that isn't a digit, thousands dot, decimal comma, or minus sign
  // (covers currency symbols like €/$ as well as multi-letter codes like "CHF").
  let s = String(raw).replace(/[^0-9.,-]/g, '')
  if (!s) return NaN
  s = s.replace(/\./g, '').replace(',', '.')
  const n = Number(s)
  return Number.isFinite(n) ? n : NaN
}

/** Split integer total as evenly as possible across `count` parts. */
export function splitTotalIntoIntegerParts(totalInt, count) {
  const t = Math.round(Number(totalInt))
  if (!Number.isFinite(t) || count <= 0) return []
  const base = Math.floor(t / count)
  const rem = t - base * count
  return Array.from({ length: count }, (_, i) => base + (i < rem ? 1 : 0))
}

/** Payout: same unit as `influencer_payout_price` (PayoutPriceField / API), not *100. */
export function splitPayoutTotalFromInput(rawTotal, count) {
  const e = parseGermanBudgetNumber(rawTotal)
  if (!Number.isFinite(e) || count <= 0) return []
  const totalInt = Math.round(e)
  return splitTotalIntoIntegerParts(totalInt, count)
}

export function fixed2(n) {
  const x = Number(n)
  return Number.isFinite(x) ? x.toFixed(2) : '0.00'
}

export function parseScopeCountToInt(value) {
  if (value == null || value === '') return 0
  const s = String(value).trim().replace(/\s/g, '')
  const n = parseInt(s.replace(/\./g, ''), 10)
  return Number.isFinite(n) ? n : 0
}

export function parsePercentInput(raw) {
  if (raw == null) return NaN
  const s = String(raw).trim().replace('%', '').replace(/\s/g, '').replace(',', '.')
  if (!s) return NaN
  const n = Number(s)
  return Number.isFinite(n) ? n : NaN
}
